/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The PostItemData model module.
 * @module model/PostItemData
 * @version 1.0
 */
class PostItemData {
    /**
     * Constructs a new <code>PostItemData</code>.
     * @alias module:model/PostItemData
     */
    constructor() { 
        
        PostItemData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PostItemData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PostItemData} obj Optional instance to populate.
     * @return {module:model/PostItemData} The populated <code>PostItemData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PostItemData();

            if (data.hasOwnProperty('itemId')) {
                obj['itemId'] = ApiClient.convertToType(data['itemId'], 'Number');
            }
            if (data.hasOwnProperty('itemQuantity')) {
                obj['itemQuantity'] = ApiClient.convertToType(data['itemQuantity'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PostItemData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PostItemData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} itemId
 */
PostItemData.prototype['itemId'] = undefined;

/**
 * @member {Number} itemQuantity
 */
PostItemData.prototype['itemQuantity'] = undefined;






export default PostItemData;

